import { normalizeCardData, normalizeCardSettings } from "./Normalizers";
import useCallAxios from "./useCallAxios";

const filterQuery = (values) => ({ ...values });

export const useCardSettings = () => {
  const context = `cardSettings`;
  const {
    reset,
    requestSuccess,
    requestData,
    requestLoading,
    requestError,
    fetchGET,
  } = useCallAxios({
    context,
  });

  const handleGET = (params) => {
    fetchGET({ context, queryParameters: filterQuery(params) });
  };

  const state = normalizeCardSettings(requestData);

  return {
    reset,
    loading: requestLoading,
    state,
    success: requestSuccess,
    error: requestError,
    handleGET,
  };
};

export const useCardData = () => {
  const context = `cardStatement`;
  const { reset, requestSuccess, requestData, requestLoading, fetchGET } =
    useCallAxios({
      context,
    });

  const handleGET = (params) => {
    fetchGET({ context, queryParameters: filterQuery(params) });
  };

  const state = normalizeCardData(requestData);

  return {
    reset,
    loading: requestLoading,
    state,
    success: requestSuccess,
    handleGET,
  };
};
